import { render, staticRenderFns } from "./LafiaOptionGroupItem.vue?vue&type=template&id=ddf23f8e&scoped=true"
import script from "./LafiaOptionGroupItem.vue?vue&type=script&lang=js"
export * from "./LafiaOptionGroupItem.vue?vue&type=script&lang=js"
import style0 from "./LafiaOptionGroupItem.vue?vue&type=style&index=0&id=ddf23f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../컨셉펀딩/worktrees/yesandlegeyo-copy-test-20260921/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf23f8e",
  null
  
)

export default component.exports